import Vue from 'vue';
import AlertsModal from './AlertsModal.vue';
import { BfSpinner, BfButton } from 'components/Butterfly';
import AlertsAPI from 'src/api/alerts';
const AlertsPage = Vue.extend({
    components: {
        AlertsModal,
        BfSpinner,
        BfButton,
    },
    data() {
        return {
            selectedDashboard: null,
            selectedProject: null,
            alerts: [],
            loading: false,
        };
    },
    computed: {
        sortedProjects() {
            return this.getSortedProjects();
        },
        filteredProjects() {
            return this.getSortedProjects(true);
        },
    },
    mounted() {
        this.fetchAlerts();
    },
    methods: {
        async fetchAlerts() {
            this.loading = true;
            const res = await AlertsAPI.getAlerts();
            this.alerts = res?.results ?? [];
            this.loading = false;
        },
        getSortedProjects(filter = false) {
            // Sort Alerts into Dashboards
            const dashboards = [];
            for (const alert of this.alerts) {
                const dashboardID = alert.dashboard.id;
                if (filter && this.selectedDashboard) {
                    if (dashboardID !== this.selectedDashboard.id) {
                        continue;
                    }
                }
                const dashboard = dashboards.find(d => d.id === dashboardID);
                if (dashboard) {
                    dashboard.alerts.push(alert);
                }
                else {
                    dashboards.push({
                        id: alert.dashboard.id,
                        name: alert.dashboard.name,
                        alerts: [alert],
                    });
                }
            }
            // Sort Dashboards into Projects
            const projects = [];
            for (const dashboard of dashboards) {
                const projectID = dashboard.alerts[0].project.id;
                if (filter && this.selectedProject) {
                    if (projectID !== this.selectedProject.id) {
                        continue;
                    }
                }
                const project = projects.find(p => p.id === projectID);
                if (project) {
                    project.dashboards.push(dashboard);
                }
                else {
                    projects.push({
                        id: dashboard.alerts[0].project.id,
                        name: dashboard.alerts[0].project.name,
                        dashboards: [dashboard],
                    });
                }
            }
            return projects;
        },
        openModal(alert) {
            if (alert) {
                this.$refs.alertsModal.open(alert.id, {
                    title: alert.title,
                    description: alert.description,
                });
                return;
            }
            this.$refs.alertsModal.open();
        },
        async deleteAlert(alert) {
            await AlertsAPI.deleteAlert(alert.id);
            this.fetchAlerts();
        },
    },
});
export default AlertsPage;
